module.exports = __webpack_public_path__ + "nab.eot?23161f576150168f5473166803e64b9d";


//////////////////
// WEBPACK FOOTER
// ./~/@nsftx/nfont/css/fonts/nab.eot
// module id = 60
// module chunks = 0